module.exports = "<div class=\"mb-1\" style=\"white-space:pre-wrap;text-align:left;\" [innerHTML]=\"currentText\">\n</div>\n<a *ngIf=\"displayReadToggle()\" [class.hidden]=\"hideToggle\" (click)=\"toggleView()\" class=\"read-more\">\n    <span>Read {{isCollapsed? 'more +':'less -'}} </span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/read-more/read-more.component.html
// module id = ../../../../../src/app/shared/read-more/read-more.component.html
// module chunks = main